<template>
  <div class="qa-card">
    <div class="card-header">
      <div class="title-wrap">
        <h4 class="title">{{title || '自测题'}}</h4>
      </div>
      <div class="menu-wrap">
        <slot></slot>
      </div>
    </div>
    <div class="exam-description">
      <VueEditor
        :content="description"
        @change="handleItemDescriptionChange"
        placeholder="请输入题目，为确保智能组卷功能，题目中无需输入序号数字"
      />
    </div>
    <div class="exam-option">
      <div
        class="option-item"
        v-for="(item, $index) in options"
        :key="item.id"
      >
        <div class="left">
          <span class="label">{{keys[$index]}}</span>
          <div class="input-box">
            <VueEditor
              :content="item.description"
              :simple="true"
              @change="handleAnswerDescriptionChange($event, $index)"
              placeholder="请输入答案选项"
            />
          </div>
          <div class="result">
            <el-checkbox
              v-model="item.true_option"
              @change="handleOptionChange($event, $index)"
            >正确答案</el-checkbox>
          </div>
        </div>
        <!-- <div class="right">
          <div class="action-wrap">
            <div v-if="$index != 0">
              <el-button type="text" @click="handleOptionSortChange($index, 'up')">上移</el-button>
              <el-divider class="divider" direction="vertical"></el-divider>
            </div>
            <div v-if="$index != options.length-1">
              <el-button type="text" @click="handleOptionSortChange($index, 'down')">下移</el-button>
              <el-divider class="divider" direction="vertical"></el-divider>
            </div>
            <el-button type="text" @click="handleOptionRemove(item, $index)">删除</el-button>
            <div v-if="$index == options.length-1">
              <el-divider class="divider" direction="vertical"></el-divider>
              <el-button type="text" @click="handleOptionAdd">新增</el-button>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="exam-parse">
      <VueEditor
        :content="solveGuide"
        @change="handleSolveGuideChange"
        placeholder="请输入答案解析"
      />
    </div>
    <div class="exam-parse">
      <el-input
        class="video-url"
        v-model="videoUrl"
        placeholder="视频解析地址"
        @change="handleItemVideoUrlChange"
      ></el-input>
    </div>
  </div>
</template>

<script>
import VueEditor from '@/components/VueEditor'
import {
  examItemUpdate,
  examAnswerCreate, examAnswerUpdate, examAnswersUpdate, examAnswerDestroy
} from '@/api/exam'

let Timer = null       // 定时器
let TimerTime = 500    // 定时器 等待时长

export default {
  components: {
    VueEditor
  },
  props: {
    title: String,
    content: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      keys: `ABCDEFGHIJKLMNOPQRSTUVWXYZ`.split(''),
      description: this.content.description || '',
      solveGuide: this.content.solve_guide || '',
      videoUrl: this.content.video_analysis_url || '',
      options: this.content.options || []
    }
  },
  watch: {
    content(val) { }
  },
  methods: {
    // 正确答案变化
    handleOptionChange(value, index) {
      if (value) {
        this.options.forEach((item, i) => {
          if (i !== index) {
            item.true_option = false
          }
        })
      }
      const rows = this.options.map(item => {
        return { id: item.id, true_option: item.true_option ? 1 : 0 }
      })
      examAnswersUpdate(rows).then(res => {
        // 数据向外层传递
        this.handleExamSave()
      }).catch(error => {
        this.$message.error('正确答案项设置异常')
        console.log('error: ', error)
      })
    },
    // 新增选项
    handleOptionAdd() {
      let newAnswer = {
        item_id: this.content.id,
        description: '',
        true_option: 0,
        sort: this.options.length
      }
      examAnswerCreate(newAnswer).then(res => {
        this.options.push(res)

        // 数据向外层传递
        this.handleExamSave()
      }).catch(error => {
        console.log('error: ', error)
      })
    },
    // 删除选项
    handleOptionRemove(item, index) {
      // 二次确认撤销
      this.$confirm(
        "确定要删除吗？题目被多处引用时，进行删除操作可能会产生不良影响，请谨慎操作。",
        "提示",
        {
          confirmButtonText: '确定删除',
          type: "warning",
        }
      ).then(() => {
        examAnswerDestroy({ id: item.id }).then(res => {
          this.options.splice(index, 1)
          // 数据向外层传递
          this.handleExamSave()
        }).catch(error => {
          this.$message.error('答案项删除失败')
          console.log('error: ', error)
        })
      }).catch(() => { });
    },
    // 排序选项
    handleOptionSortChange(index, type) {
      let old = this.options.splice(index, 1)[0]
      if (type == 'up') {
        this.options.splice(index - 1, 0, old)
      } else if (type == 'down') {
        this.options.splice(index + 1, 0, old)
      }
      const rows = this.options.map((item, sort) => {
        return { id: item.id, sort: sort }
      })
      examAnswersUpdate(rows).then(res => {
        // 数据向外层传递
        this.handleExamSave()
      }).catch(error => {
        this.$message.error('答案项排序更新异常')
        console.log('error: ', error)
      })
    },
    // 答案项描述变动
    handleAnswerDescriptionChange(editor, index) {
      this.options[index].description = editor.html
      let row = {
        id: this.options[index].id,
        description: this.options[index].description
      }
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        examAnswerUpdate(row).then(res => {
          // 数据向外层传递
          this.handleExamSave()
        }).catch(error => {
          this.$message.error('答案项描述更新异常')
          console.log('error: ', error)
        })
      }, TimerTime)
    },
    // 题目描述变动
    handleItemDescriptionChange(editor) {
      this.description = editor.html
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        examItemUpdate({ id: this.content.id, description: this.description }).then(res => {
          // 数据向外层传递
          this.handleExamSave()
        }).catch(error => {
          this.$message.error('题目描述更新异常')
          console.log('error: ', error)
        })
      }, TimerTime)
    },
    // 题目解析更新
    handleSolveGuideChange(editor) {
      this.solveGuide = editor.html
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        examItemUpdate({ id: this.content.id, solve_guide: this.solveGuide }).then(res => {
          // 数据向外层传递
          this.handleExamSave()
        }).catch(error => {
          this.$message.error('题目描述更新异常')
          console.log('error: ', error)
        })
      }, TimerTime)
    },
    // 视频解析地址更新
    handleItemVideoUrlChange(value) {
      this.videoUrl = value
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        examItemUpdate({ id: this.content.id, video_analysis_url: this.videoUrl }).then(res => {
          // 数据向外层传递
          this.handleExamSave()
        }).catch(error => {
          this.$message.error('视频解析地址更新异常')
          console.log('error: ', error)
        })
      }, TimerTime)
    },
    handleExamSave() {
      this.$emit('save', {
        description: this.description,
        solve_guide: this.solveGuide,
        options: this.options
      })
    }
  }
}
</script>

<style scoped lang="less">
.qa-card {
  position: relative;
  color: #303133;
  background-color: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  background: #f2f2f2;
  padding: 20px;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .title-wrap {
      display: flex;
      align-items: center;

      .title {
        font-size: 18px;
        font-weight: bold;
        color: #0091ff;
        margin-right: 20px;
      }
    }
    .menu-wrap {
      display: flex;
      align-items: center;

      /deep/ .el-button {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }

  .vueEditor {
    /deep/ .ql-container {
      min-height: 80px;
    }
  }
  .exam-option {
    background: #fff;
    padding: 20px;
    margin-top: 10px;
  }
  .option-item {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & + .option-item {
      margin-top: 10px;
    }
    .left {
      display: flex;
      align-items: center;
    }
    .label {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      color: #0091ff;
      border-radius: 12px;
      border: 1px solid #0091ff;
      margin-right: 10px;
    }
    .input-box {
      width: 500px;
    }
    .result {
      margin-left: 10px;
    }

    .right {
      display: flex;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: center;
      width: 115px;

      > div:last-child {
        .divider {
          display: none;
        }
      }
    }
  }

  .exam-parse {
    margin-top: 10px;

    .video-url /deep/ input {
      border-radius: 0;
      border-color: #c0c4cc;

      &:focus {
        border-color: #c0c4cc;
      }
    }
  }
}
</style>
